import { render } from "./boxSearchMovie.vue?vue&type=template&id=c3230dfe&scoped=true"
import script from "./boxSearchMovie.vue?vue&type=script&lang=js"
export * from "./boxSearchMovie.vue?vue&type=script&lang=js"

import "./boxSearchMovie.vue?vue&type=style&index=0&id=c3230dfe&scoped=true&lang=css"

import exportComponent from "F:\\Project Coustomer\\vue film\\film\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3230dfe"]])

export default __exports__